import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { CalendarDays } from "lucide-react";

/** Get days count from ticket (snake_case or camelCase from API). */
export function getDaysSinceSubmission(ticket: {
  days_count_since_submission?: number;
  daysCountSinceSubmission?: number;
}): number | undefined {
  const n =
    ticket.days_count_since_submission ?? ticket.daysCountSinceSubmission;
  return typeof n === "number" ? n : undefined;
}

interface DaysSinceSubmissionBadgeProps {
  /** Days since submission (from getDaysSinceSubmission(ticket)). Not shown when 0 or undefined. */
  days: number | undefined;
  className?: string;
}

export function DaysSinceSubmissionBadge({ days, className }: DaysSinceSubmissionBadgeProps) {
  if (days == null || days === 0) return null;

  const label = days === 1 ? "1 day since submission" : `${days} days since submission`;

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge variant="secondary" className={className} title={label}>
            <CalendarDays className="h-3 w-3 mr-1" />
            {days}d
          </Badge>
        </TooltipTrigger>
        <TooltipContent side="top">
          {label}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
